import React, { useState, useEffect } from "react";
import StatCard from "./statCard";
import { Section, Container, Title } from "./styles";
import { CpuIcon, GpuIcon, RamIcon, DiskIcon, OsIcon, UserIcon } from "./icon";
import { instanceAPI } from "api";
import { getTaskData } from "api/taskStatus";

const SystemSummaryPannel = ({ instance }) => {
  const [metricData, setMetricData] = useState<any>({});

  useEffect(() => {
    const fetchData = async () => {
      const instanceData = await getTaskData(() =>
        instanceAPI.getInstance(instance)
      );
      setMetricData(instanceData?.result?.data ?? {});
    };
    fetchData();
  }, [instance]);

  return (
    <Section>
      <Title>Summary</Title>
      <Container>
        <StatCard
          tag="CPU 코어"
          data={metricData.cpu ?? "N/A"}
          unit={""}
          icon={<CpuIcon />}
          accent="orange"
          hint="vCPU 개수"
        />

        <StatCard
          tag="VGPU"
          data={metricData.vgpu ?? "N/A"}
          unit={""}
          icon={<GpuIcon />}
          accent="violet"
          hint="할당된 가상 GPU"
        />

        <StatCard
          tag="RAM"
          data={metricData.ram ?? "N/A"}
          unit={metricData.ram != null ? "GiB" : undefined}
          icon={<RamIcon />}
          accent="emerald"
          hint="시스템 메모리"
        />

        <StatCard
          tag="Disk"
          data={metricData.disk ?? "N/A"}
          unit={""}
          icon={<DiskIcon />}
          accent="sky"
          hint="루트 볼륨 또는 총 디스크 용량"
        />

        <StatCard
          tag="OS"
          data={metricData.os ?? "N/A"}
          unit={""}
          icon={<OsIcon />}
          accent="zinc"
          hint="운영체제"
        />

        <StatCard
          tag="로그인"
          data={metricData.login ?? "N/A"}
          unit={""}
          icon={<UserIcon />}
          accent="indigo"
          hint="현재 로그인 사용자"
        />
      </Container>
    </Section>
  );
};

export default SystemSummaryPannel;
